"use strict";
//
// Copyright © 2023 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactCache = void 0;
exports.getCurrentEmployee = getCurrentEmployee;
exports.getCurrentEmployeeSpace = getCurrentEmployeeSpace;
exports.addEmployeeListenrer = addEmployeeListenrer;
exports.setCurrentEmployee = setCurrentEmployee;
exports.setCurrentEmployeeSpace = setCurrentEmployeeSpace;
exports.isDocCreatedByAccount = isDocCreatedByAccount;
exports.getAvatarColorForId = getAvatarColorForId;
exports.getAvatarColors = getAvatarColors;
exports.getAvatarColorName = getAvatarColorName;
exports.getAvatarProviderId = getAvatarProviderId;
exports.getGravatarUrl = getGravatarUrl;
exports.checkHasGravatar = checkHasGravatar;
exports.findContacts = findContacts;
exports.findPerson = findPerson;
exports.combineName = combineName;
exports.getFirstName = getFirstName;
exports.getLastName = getLastName;
exports.formatName = formatName;
exports.getName = getName;
exports.formatContactName = formatContactName;
exports.includesAny = includesAny;
exports.getPersonBySocialKey = getPersonBySocialKey;
exports.getEmployeeBySocialId = getEmployeeBySocialId;
exports.getPersonRefsBySocialIds = getPersonRefsBySocialIds;
exports.getPrimarySocialId = getPrimarySocialId;
exports.getAllSocialStringsByPersonId = getAllSocialStringsByPersonId;
exports.getAllSocialStringsByPersonRef = getAllSocialStringsByPersonRef;
exports.getSocialStringsByEmployee = getSocialStringsByEmployee;
exports.getAllAccounts = getAllAccounts;
exports.getAllUserAccounts = getAllUserAccounts;
exports.ensureEmployee = ensureEmployee;
exports.ensureEmployeeForPerson = ensureEmployeeForPerson;
exports.loadCachesForPersonId = loadCachesForPersonId;
exports.loadCachesForPersonIds = loadCachesForPersonIds;
exports.loadCachesForPersonRef = loadCachesForPersonRef;
exports.loadCachesForPersonRefs = loadCachesForPersonRefs;
exports.getPersonRefByPersonId = getPersonRefByPersonId;
exports.getPersonRefByPersonIdCb = getPersonRefByPersonIdCb;
exports.getPersonRefsByPersonIds = getPersonRefsByPersonIds;
exports.getPersonRefsByPersonIdsCb = getPersonRefsByPersonIdsCb;
exports.getPersonByPersonId = getPersonByPersonId;
exports.getPersonByPersonIdCb = getPersonByPersonIdCb;
exports.getPersonsByPersonIds = getPersonsByPersonIds;
exports.getPersonsByPersonIdsCb = getPersonsByPersonIdsCb;
exports.getPersonByPersonRef = getPersonByPersonRef;
exports.getPersonByPersonRefCb = getPersonByPersonRefCb;
exports.getPersonsByPersonRefs = getPersonsByPersonRefs;
exports.getPersonsByPersonRefsCb = getPersonsByPersonRefsCb;
exports.getSocialIdByPersonId = getSocialIdByPersonId;
exports.getSocialIdByPersonIdCb = getSocialIdByPersonIdCb;
const core_1 = require("@hcengineering/core");
const platform_1 = __importStar(require("@hcengineering/platform"));
const _1 = __importStar(require("."));
const types_1 = require("./types");
const cache_1 = __importDefault(require("./cache"));
let currentEmployee;
let currentEmployeeSpace;
const employeeListeners = [];
/**
 * @public
 * @returns
 */
function getCurrentEmployee() {
    return currentEmployee;
}
function getCurrentEmployeeSpace() {
    return currentEmployeeSpace;
}
function addEmployeeListenrer(l) {
    employeeListeners.push(l);
}
/**
 * @public
 * @param employee -
 */
function setCurrentEmployee(employee) {
    currentEmployee = employee;
    for (const l of employeeListeners) {
        l(employee);
    }
}
function setCurrentEmployeeSpace(space) {
    currentEmployeeSpace = space;
}
/**
 * True when {@link Doc.createdBy} is one of the given account's social identities.
 *
 * @public
 */
function isDocCreatedByAccount(doc, account) {
    const creator = doc.createdBy;
    if (creator === undefined)
        return false;
    if (creator === account.primarySocialId)
        return true;
    return account.socialIds.includes(creator);
}
/**
 * @public
 */
function getAvatarColorForId(id) {
    if (id == null)
        return types_1.AVATAR_COLORS[0].color;
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
        hash += id.charCodeAt(i);
    }
    return types_1.AVATAR_COLORS[hash % types_1.AVATAR_COLORS.length].color;
}
/**
 * @public
 */
function getAvatarColors() {
    return types_1.AVATAR_COLORS;
}
/**
 * @public
 */
function getAvatarColorName(color) {
    return types_1.AVATAR_COLORS.find((col) => col.color === color)?.name ?? types_1.AVATAR_COLORS[0].name;
}
/**
 * @public
 */
function getAvatarProviderId(kind) {
    switch (kind) {
        case _1.AvatarType.GRAVATAR:
            return _1.default.avatarProvider.Gravatar;
        case _1.AvatarType.COLOR:
            return _1.default.avatarProvider.Color;
    }
    return _1.default.avatarProvider.Image;
}
/**
 * @public
 */
function getGravatarUrl(gravatarId, width = 64, placeholder = 'identicon') {
    return `https://gravatar.com/avatar/${gravatarId}?s=${width}&d=${placeholder}`;
}
/**
 * @public
 */
async function checkHasGravatar(gravatarId, fetch) {
    try {
        return (await (fetch ?? window.fetch)(getGravatarUrl(gravatarId, 2048, '404'))).ok;
    }
    catch {
        return false;
    }
}
/**
 * @public
 */
async function findContacts(client, _class, name, channels) {
    if (channels.length === 0 && name.length === 0) {
        return { contacts: [], channels: [] };
    }
    // Take only first part of first name for match.
    const values = channels.map((it) => it.value);
    // Same name persons
    const potentialChannels = await client.findAll(_1.default.class.Channel, { value: { $in: values } }, { limit: 1000 });
    let potentialContactIds = Array.from(new Set(potentialChannels.map((it) => it.attachedTo)).values());
    if (potentialContactIds.length === 0) {
        if (client.getHierarchy().isDerived(_class, _1.default.class.Person)) {
            const firstName = getFirstName(name).split(' ').shift() ?? '';
            const lastName = getLastName(name);
            // try match using just first/last name
            potentialContactIds = (await client.findAll(_1.default.class.Contact, { name: { $like: `${lastName}%${firstName}%` } }, { limit: 100 })).map((it) => it._id);
            if (potentialContactIds.length === 0) {
                return { contacts: [], channels: [] };
            }
        }
        else if (client.getHierarchy().isDerived(_class, _1.default.class.Organization)) {
            // try match using just first/last name
            potentialContactIds = (await client.findAll(_1.default.class.Contact, { name: { $like: `${name}` } }, { limit: 100 })).map((it) => it._id);
            if (potentialContactIds.length === 0) {
                return { contacts: [], channels: [] };
            }
        }
    }
    const potentialPersons = await client.findAll(_1.default.class.Contact, { _id: { $in: potentialContactIds } }, {
        lookup: {
            _id: {
                channels: _1.default.class.Channel
            }
        }
    });
    const result = [];
    const resChannels = [];
    for (const c of potentialPersons) {
        let matches = 0;
        if (c.name === name) {
            matches++;
        }
        for (const ch of c.$lookup?.channels ?? []) {
            for (const chc of channels) {
                if (chc.provider === ch.provider && chc.value === ch.value.trim()) {
                    // We have matched value
                    resChannels.push(chc);
                    matches += 2;
                    break;
                }
            }
        }
        if (matches > 0) {
            result.push(c);
        }
    }
    return { contacts: result, channels: resChannels };
}
/**
 * @public
 */
async function findPerson(client, name, channels) {
    const result = await findContacts(client, _1.default.class.Person, name, channels);
    return result.contacts;
}
const SEP = ',';
/**
 * @public
 */
function combineName(first, last) {
    return (last ?? '') + SEP + (first ?? '');
}
/**
 * @public
 */
function getFirstName(name) {
    return name !== undefined ? name.substring(name.indexOf(SEP) + 1) : '';
}
/**
 * @public
 */
function getLastName(name) {
    return name !== undefined ? name.substring(0, name.indexOf(SEP)) : '';
}
/**
 * @public
 */
function formatName(name, lastNameFirst) {
    const lastNameFirstCombined = lastNameFirst !== undefined ? lastNameFirst === 'true' : (0, platform_1.getMetadata)(_1.default.metadata.LastNameFirst) === true;
    return lastNameFirstCombined
        ? getLastName(name) + ' ' + getFirstName(name)
        : getFirstName(name) + ' ' + getLastName(name);
}
/**
 * @public
 */
function getName(hierarchy, value, lastNameFirst) {
    if (isPerson(hierarchy, value)) {
        return formatName(value.name, lastNameFirst);
    }
    return value.name;
}
function isPerson(hierarchy, value) {
    return isPersonClass(hierarchy, value._class);
}
function isPersonClass(hierarchy, _class) {
    return hierarchy.isDerived(_class, _1.default.class.Person);
}
/**
 * @public
 */
function formatContactName(hierarchy, _class, name, lastNameFirst) {
    if (isPersonClass(hierarchy, _class)) {
        return formatName(name, lastNameFirst);
    }
    return name;
}
function includesAny(members, ids) {
    return members.some((m) => ids.includes(m));
}
async function getPersonBySocialKey(client, socialKey) {
    const socialId = await client.findOne(_1.default.class.SocialIdentity, { key: socialKey });
    if (socialId === undefined)
        return undefined;
    return await client.findOne(_1.default.class.Person, { _id: socialId?.attachedTo, _class: socialId?.attachedToClass });
}
async function getEmployeeBySocialId(client, socialIdString) {
    const socialId = await client.findOne(_1.default.class.SocialIdentity, { _id: socialIdString });
    if (socialId === undefined)
        return undefined;
    return await client.findOne(_1.default.mixin.Employee, { _id: socialId.attachedTo });
}
async function getPersonRefsBySocialIds(client, ids = []) {
    const socialIds = await client.findAll(_1.default.class.SocialIdentity, ids.length === 0 ? {} : { _id: { $in: ids } });
    const result = {};
    for (const socialId of socialIds) {
        result[socialId._id] = socialId.attachedTo;
    }
    return result;
}
async function getPrimarySocialId(client, person) {
    const socialIds = await client.findAll(_1.default.class.SocialIdentity, { attachedTo: person, verifiedOn: { $gt: 0 } });
    if (socialIds.length === 0) {
        return;
    }
    return (0, core_1.pickPrimarySocialId)(socialIds)._id;
}
async function getAllSocialStringsByPersonId(client, personId) {
    const socialId = await client.findOne(_1.default.class.SocialIdentity, {
        _id: personId,
        attachedToClass: _1.default.class.Person
    });
    if (socialId === undefined) {
        return [];
    }
    const socialIds = await client.findAll(_1.default.class.SocialIdentity, { attachedTo: socialId.attachedTo });
    return socialIds.map((it) => it._id);
}
async function getAllSocialStringsByPersonRef(client, person) {
    const socialIds = await client.findAll(_1.default.class.SocialIdentity, { attachedTo: person });
    return socialIds.map((it) => it._id);
}
async function getSocialStringsByEmployee(client) {
    const employees = await client.findAll(_1.default.mixin.Employee, { active: true });
    const socialIds = await client.findAll(_1.default.class.SocialIdentity, {
        attachedTo: { $in: employees.map((it) => it._id) },
        attachedToClass: _1.default.class.Person
    });
    const socialStringsByPerson = {};
    for (const socialId of socialIds) {
        const socialStrings = socialStringsByPerson[socialId.attachedTo];
        if (socialStrings === undefined) {
            socialStringsByPerson[socialId.attachedTo] = [];
        }
        socialStrings.push(socialId._id);
    }
    return socialStringsByPerson;
}
async function getAllAccounts(client) {
    const employees = await client.findAll(_1.default.mixin.Employee, { active: true });
    return employees.map((it) => it.personUuid).filter(core_1.notEmpty);
}
async function getAllUserAccounts(client) {
    const employees = await client.findAll(_1.default.mixin.Employee, { active: true });
    return employees.map((it) => it.personUuid).filter(core_1.notEmpty);
}
async function ensureEmployee(ctx, me, client, socialIds, getGlobalPerson, options) {
    const globalPerson = await getGlobalPerson();
    return await ensureEmployeeForPerson(ctx, me, me, client, socialIds, globalPerson, options);
}
async function ensureEmployeeForPerson(ctx, me, person, client, socialIds, globalPerson, options) {
    const createEmployee = options?.createEmployee ?? true;
    const maxRetries = 3;
    let retryCount = 0;
    let personRef;
    while (retryCount <= maxRetries) {
        const txFactory = new core_1.TxFactory(me.primarySocialId);
        const personByUuid = await client.findOne(_1.default.class.Person, { personUuid: person.uuid });
        personRef = personByUuid?._id;
        if (personRef === undefined) {
            const socialIdentity = await client.findOne(_1.default.class.SocialIdentity, {
                _id: { $in: person.socialIds }
            });
            // This social id is confirmed globally as we only have ids of confirmed social identities in socialIds array
            personRef = socialIdentity?.attachedTo;
        }
        if (personRef !== undefined) {
            // Person found, break out of retry loop
            break;
        }
        // Local person not found: neither by personUuid nor by a local social identity
        // Creating a new local person using TxApplyIf to prevent race conditions
        let shouldRetry = false;
        await ctx.with('create-person', {}, async () => {
            if (globalPerson === undefined) {
                console.error('Cannot get global person');
                return null;
            }
            const data = {
                personUuid: person.uuid,
                name: combineName(globalPerson.firstName, globalPerson.lastName),
                city: '',
                avatarType: _1.AvatarType.COLOR
            };
            personRef = (0, core_1.generateId)();
            const createPersonTx = txFactory.createTxCreateDoc(_1.default.class.Person, _1.default.space.Contacts, data, personRef);
            // Use TxApplyIf with notMatch to atomically check that no Person with this personUuid exists
            // This prevents duplicate Person creation under concurrent ensureEmployee calls
            const applyTx = txFactory.createTxApplyIf(_1.default.space.Contacts, `ensure-person-${person.uuid}`, [], [{ _class: _1.default.class.Person, query: { personUuid: person.uuid } }], [createPersonTx], 'ensureEmployee');
            const txResult = await client.tx(applyTx);
            // Re-check: if our TxApplyIf was rejected (another concurrent call won the race),
            // find the Person that was created by the winner
            const existingPerson = await client.findOne(_1.default.class.Person, { personUuid: person.uuid });
            if (existingPerson !== undefined) {
                personRef = existingPerson._id;
            }
            else if (!txResult.success) {
                // TxApplyIf was rejected and we couldn't find the existing person yet
                // Mark for retry - another concurrent call may have created it
                shouldRetry = true;
                personRef = undefined;
            }
        });
        if (!shouldRetry) {
            // TxApplyIf succeeded or person was found, break out of retry loop
            break;
        }
        // TxApplyIf was rejected and we haven't found the person, retry
        retryCount++;
        if (retryCount <= maxRetries) {
            // Small delay to allow the other concurrent operation to complete
            await new Promise((resolve) => setTimeout(resolve, 10 * retryCount));
        }
    }
    if (personRef === undefined) {
        console.error('Failed to find or create person after retries');
        return null;
    }
    try {
        const txFactory = new core_1.TxFactory(me.primarySocialId);
        // Check if person was found by social identity but missing personUuid
        const personByUuidNow = await client.findOne(_1.default.class.Person, { personUuid: person.uuid });
        if (personByUuidNow === undefined) {
            // Local person found only by social identity, need to set personUuid
            const updatePersonTx = txFactory.createTxUpdateDoc(_1.default.class.Person, _1.default.space.Contacts, personRef, {
                personUuid: person.uuid
            });
            await client.tx(updatePersonTx);
        }
        const existingIdentifiers = (0, core_1.toIdMap)(await client.findAll(_1.default.class.SocialIdentity, { _id: { $in: person.socialIds } }));
        for (const socialId of socialIds) {
            const existing = existingIdentifiers.get(socialId._id);
            if (existing == null) {
                await ctx.with('create-social-identity', {}, async () => {
                    if (personRef === undefined) {
                        // something went wrong
                        console.error('Person not found');
                        return null;
                    }
                    const createSocialIdTx = txFactory.createTxCollectionCUD(_1.default.class.Person, personRef, _1.default.space.Contacts, 'socialIds', txFactory.createTxCreateDoc(_1.default.class.SocialIdentity, _1.default.space.Contacts, {
                        attachedTo: personRef,
                        attachedToClass: _1.default.class.Person,
                        collection: 'socialIds',
                        type: socialId.type,
                        value: socialId.value,
                        key: (0, core_1.buildSocialIdString)(socialId), // TODO: fill it in trigger or on DB level as stored calculated column or smth?
                        verifiedOn: socialId.verifiedOn,
                        isDeleted: socialId.isDeleted ?? false
                    }, socialId._id));
                    // Use TxApplyIf with notMatch to atomically check that no SocialIdentity with this _id exists.
                    // This prevents duplicate SocialIdentity creation under concurrent ensureEmployee calls.
                    const applyTx = txFactory.createTxApplyIf(_1.default.space.Contacts, `ensure-social-identity-${socialId._id}`, [], [{ _class: _1.default.class.SocialIdentity, query: { _id: socialId._id } }], [createSocialIdTx], 'ensureEmployee');
                    await client.tx(applyTx);
                });
            }
            else {
                // If not confirmed locally can be attached to a different person (persons merge scenario)
                // Confirmed social identity should not be attached to a different person for now
                // It will change with accounts merge function
                if (existing.verifiedOn != null && existing.attachedTo !== personRef) {
                    throw new Error('Confirmed social identity is attached to the wrong person');
                }
                // Check and update if needed. It can:
                // 1. Become verified (maybe with persons merge) (changes verifiedOn, attachedTo)
                const sidUpdate = {};
                let needUpdate = false;
                // become verified
                if (existing.verifiedOn == null) {
                    sidUpdate.verifiedOn = socialId.verifiedOn;
                    needUpdate = true;
                }
                // merged from another person
                if (existing.attachedTo !== personRef) {
                    sidUpdate.attachedTo = personRef;
                    // Bump collection in Person?
                    needUpdate = true;
                }
                // become deleted
                if (existing.isDeleted !== socialId.isDeleted && socialId.isDeleted === true) {
                    sidUpdate.value = socialId.value;
                    sidUpdate.key = socialId.key;
                    sidUpdate.isDeleted = socialId.isDeleted;
                    needUpdate = true;
                }
                if (needUpdate) {
                    const updateSocialIdentityTx = txFactory.createTxUpdateDoc(_1.default.class.SocialIdentity, _1.default.space.Contacts, existing._id, sidUpdate);
                    await client.tx(updateSocialIdentityTx);
                }
            }
        }
        // Phone is not a social id: it is never verified, so it lives on the global person as a hint.
        const phoneHint = globalPerson?.phoneHint;
        if (phoneHint != null && phoneHint !== '') {
            const existingChannel = await client.findOne(_1.default.class.Channel, {
                attachedTo: personRef,
                provider: _1.default.channelProvider.Phone,
                value: phoneHint
            });
            if (existingChannel == null) {
                const createChannelTx = txFactory.createTxCollectionCUD(_1.default.class.Person, personRef, _1.default.space.Contacts, 'channels', txFactory.createTxCreateDoc(_1.default.class.Channel, _1.default.space.Contacts, {
                    attachedTo: personRef,
                    attachedToClass: _1.default.class.Person,
                    collection: 'channels',
                    provider: _1.default.channelProvider.Phone,
                    value: phoneHint
                }));
                await client.tx(createChannelTx);
            }
        }
        // NOTE: it is important to create Employee after Person and SocialIdentities are ensured so all the triggers applied
        // on Employee creation will be able to properly map things
        if (createEmployee) {
            const employeeRole = options?.roleOverride ??
                (person.role === core_1.AccountRole.Guest || person.role === core_1.AccountRole.ReadOnlyGuest ? 'GUEST' : 'USER');
            const employee = await client.findOne(_1.default.mixin.Employee, { _id: personRef });
            if (employee === undefined ||
                !core_1.Hierarchy.hasMixin(employee, _1.default.mixin.Employee) ||
                !employee.active ||
                employee.role !== employeeRole) {
                await ctx.with('create-employee', {}, async () => {
                    if (personRef === undefined) {
                        // something went wrong
                        console.error('Person not found');
                        return null;
                    }
                    const createEmployeeTx = txFactory.createTxMixin(personRef, _1.default.class.Person, _1.default.space.Contacts, _1.default.mixin.Employee, {
                        active: true,
                        role: employeeRole
                    });
                    // Use TxApplyIf to prevent duplicate Employee mixin creation under concurrent calls.
                    // Without this, two parallel ensureEmployee calls can both see no Employee and both
                    // send TxMixin, triggering OnEmployeeCreate twice and creating duplicate PersonSpaces.
                    const applyTx = txFactory.createTxApplyIf(_1.default.space.Contacts, `ensure-employee-${person.uuid}`, [], [{ _class: _1.default.mixin.Employee, query: { _id: personRef, active: true } }], [createEmployeeTx], 'ensureEmployee');
                    await client.tx(applyTx);
                });
            }
        }
        // TODO: check for merged persons with this one and do the merge
        return personRef;
    }
    catch (err) {
        // If Forbidden error occurred, return personRef if it exists, otherwise throw error
        if (err instanceof platform_1.PlatformError && err.status.code === platform_1.default.status.Forbidden) {
            if (personRef != null) {
                ctx.info('Skip employee update for person without full access rights');
                return personRef;
            }
        }
        throw err;
    }
}
exports.contactCache = cache_1.default.instance;
async function loadCachesForPersonId(client, personId) {
    if (personId == null || personId === '')
        return;
    const sidObj = await client.findOne(_1.default.class.SocialIdentity, {
        _id: personId
    }, {
        lookup: {
            attachedTo: _1.default.class.Person
        }
    });
    exports.contactCache.fillCachesForPersonId(personId, sidObj);
}
async function loadCachesForPersonIds(client, personIds) {
    const sidObjsMap = (0, core_1.toIdMap)(await client.findAll(_1.default.class.SocialIdentity, {
        _id: { $in: personIds }
    }, {
        lookup: {
            attachedTo: _1.default.class.Person
        }
    }));
    for (const personId of personIds) {
        const sidObj = sidObjsMap.get(personId);
        exports.contactCache.fillCachesForPersonId(personId, sidObj);
    }
}
async function loadCachesForPersonRef(client, personRef) {
    const person = await client.findOne(_1.default.class.Person, {
        _id: personRef
    }, {
        lookup: {
            _id: { socialIds: _1.default.class.SocialIdentity }
        }
    });
    exports.contactCache.fillCachesForPersonRef(personRef, person);
}
async function loadCachesForPersonRefs(client, personRefs) {
    const persons = (0, core_1.toIdMap)(await client.findAll(_1.default.class.Person, {
        _id: { $in: personRefs }
    }, {
        lookup: {
            _id: { socialIds: _1.default.class.SocialIdentity }
        }
    }));
    for (const personRef of personRefs) {
        const person = persons.get(personRef);
        exports.contactCache.fillCachesForPersonRef(personRef, person);
    }
}
async function getPersonRefByPersonId(client, personId) {
    if (!exports.contactCache.personRefByPersonId.has(personId)) {
        await loadCachesForPersonId(client, personId);
    }
    return exports.contactCache.personRefByPersonId.get(personId) ?? null;
}
function getPersonRefByPersonIdCb(client, personId, cb) {
    let personRef = exports.contactCache.personRefByPersonId.get(personId);
    if (personRef !== undefined) {
        cb(personRef);
    }
    else {
        void loadCachesForPersonId(client, personId).then(() => {
            personRef = exports.contactCache.personRefByPersonId.get(personId);
            cb(personRef ?? null);
        });
    }
}
function getPersonRefsByPersonIdsFromCache(personIds) {
    return new Map(personIds
        .map((pid) => {
        const ref = exports.contactCache.personRefByPersonId.get(pid);
        return ref != null ? [pid, ref] : undefined;
    })
        .filter(core_1.notEmpty));
}
async function getPersonRefsByPersonIds(client, personIds) {
    if (personIds.some((personId) => !exports.contactCache.personRefByPersonId.has(personId))) {
        await loadCachesForPersonIds(client, personIds);
    }
    return getPersonRefsByPersonIdsFromCache(personIds);
}
function getPersonRefsByPersonIdsCb(client, personIds, cb) {
    if (personIds.some((personId) => !exports.contactCache.personRefByPersonId.has(personId))) {
        void loadCachesForPersonIds(client, personIds).then(() => {
            const personRefs = getPersonRefsByPersonIdsFromCache(personIds);
            cb(personRefs);
        });
    }
    else {
        const personRefs = getPersonRefsByPersonIdsFromCache(personIds);
        cb(personRefs);
    }
}
async function getPersonByPersonId(client, personId) {
    if (!exports.contactCache.personByPersonId.has(personId)) {
        await loadCachesForPersonId(client, personId);
    }
    return exports.contactCache.personByPersonId.get(personId) ?? null;
}
function getPersonByPersonIdCb(client, personId, cb) {
    let person = exports.contactCache.personByPersonId.get(personId);
    if (person !== undefined) {
        cb(person);
    }
    else {
        void loadCachesForPersonId(client, personId).then(() => {
            person = exports.contactCache.personByPersonId.get(personId) ?? null;
            cb(person ?? null);
        });
    }
}
function getPersonsByPersonIdsFromCache(personIds) {
    return new Map(personIds
        .map((pid) => {
        const person = exports.contactCache.personByPersonId.get(pid);
        return person != null ? [pid, person] : undefined;
    })
        .filter(core_1.notEmpty));
}
async function getPersonsByPersonIds(client, personIds) {
    if (personIds.some((personId) => !exports.contactCache.personByPersonId.has(personId))) {
        await loadCachesForPersonIds(client, personIds);
    }
    return getPersonsByPersonIdsFromCache(personIds);
}
function getPersonsByPersonIdsCb(client, personIds, cb) {
    if (personIds.some((personId) => !exports.contactCache.personByPersonId.has(personId))) {
        void loadCachesForPersonIds(client, personIds).then(() => {
            const persons = getPersonsByPersonIdsFromCache(personIds);
            cb(persons);
        });
    }
    else {
        const persons = getPersonsByPersonIdsFromCache(personIds);
        cb(persons);
    }
}
async function getPersonByPersonRef(client, personRef) {
    if (!exports.contactCache.personByRef.has(personRef)) {
        await loadCachesForPersonRef(client, personRef);
    }
    return exports.contactCache.personByRef.get(personRef) ?? null;
}
function getPersonByPersonRefCb(client, personRef, cb) {
    let person = exports.contactCache.personByRef.get(personRef);
    if (person !== undefined) {
        cb(person);
    }
    else {
        void loadCachesForPersonRef(client, personRef).then(() => {
            person = exports.contactCache.personByRef.get(personRef) ?? null;
            cb(person ?? null);
        });
    }
}
function getPersonsByPersonRefsFromCache(personRefs) {
    return new Map(personRefs
        .map((personRef) => {
        const person = exports.contactCache.personByRef.get(personRef);
        return person != null ? [personRef, person] : undefined;
    })
        .filter(core_1.notEmpty));
}
async function getPersonsByPersonRefs(client, personRefs) {
    if (personRefs.some((personRef) => !exports.contactCache.personByRef.has(personRef))) {
        await loadCachesForPersonRefs(client, personRefs);
    }
    return getPersonsByPersonRefsFromCache(personRefs);
}
function getPersonsByPersonRefsCb(client, personRefs, cb) {
    if (personRefs.some((personRef) => !exports.contactCache.personByRef.has(personRef))) {
        void loadCachesForPersonRefs(client, personRefs).then(() => {
            const persons = getPersonsByPersonRefsFromCache(personRefs);
            cb(persons);
        });
    }
    else {
        const persons = getPersonsByPersonRefsFromCache(personRefs);
        cb(persons);
    }
}
async function getSocialIdByPersonId(client, personId) {
    if (!exports.contactCache.personRefByPersonId.has(personId)) {
        await loadCachesForPersonId(client, personId);
    }
    return exports.contactCache.socialIdByPersonId.get(personId) ?? null;
}
function getSocialIdByPersonIdCb(client, personId, cb) {
    let socialId = exports.contactCache.socialIdByPersonId.get(personId);
    if (socialId !== undefined) {
        cb(socialId);
    }
    else {
        void loadCachesForPersonId(client, personId).then(() => {
            socialId = exports.contactCache.socialIdByPersonId.get(personId) ?? null;
            cb(socialId ?? null);
        });
    }
}
//# sourceMappingURL=utils.js.map